module.exports = __webpack_public_path__ + "static/media/smiley.eb118509.png";